import { DialogOptions, useDialog } from './useDialog';

export function usePresetDialogs() {
  const { showDialog, DialogComponent } = useDialog();

  const showInfo = (message: string, title = 'Информация') =>
    showDialog({
      title,
      message,
      buttons: [{ label: 'OK', value: true, color: 'primary', autoFocus: true }],
    });

  const showConfirm = (message: string, title = 'Подтверждение') =>
    showDialog({
      title,
      message,
      buttons: [
        { label: 'Так', value: true, color: 'primary' },
        { label: 'Ні', value: false, color: 'error' },
      ],
    });

  const showPrompt = (message: string, defaultValue = '', title = 'Введите данные') =>
    showDialog({
      title,
      message,
      input: true,
      defaultValue,
      buttons: [
        { label: 'Відмінити', value: null, color: 'error' },
        { label: 'OK', value: 'ok', color: 'primary', autoFocus: true },
      ],
    });

  const showOptions = <T,>(message: string, options: T[], title = 'Выберите вариант') =>
    showDialog({
      title,
      message,
      buttons: options.map((opt) => ({ label: String(opt), value: opt })),
    });

  return { showInfo, showConfirm, showPrompt, showOptions, DialogComponent };
}
